module.exports = __webpack_public_path__ + "static/media/calendaricon.3a88d8f1.png";